var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"search-btn",attrs:{"depressed":"","small":"","disabled":_vm.disabled,"outlined":"","color":"primary","type":"submit"},on:{"click":function($event){return _vm.$emit('onclick')}}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("search")]),_c('span',[_vm._v("Search")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }